import React, { useState } from "react"; // ✅ useState 추가
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logoImage from "../../assets/images/logoN.png";
import logoFImage from "../../assets/images/logoF.png";

export const Navbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // ✅ 모바일 메뉴 토글 상태
  const [openSubMenu, setOpenSubMenu] = useState(null); // ✅ 서브메뉴 토글 상태
  const isLoggedIn = !!localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    alert("로그아웃 되었습니다.");
    navigate("/");
    closeAllMenus(); // 로그아웃 시 메뉴 완전히 닫기
  };

  // ✅ 메뉴 토글 함수
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenSubMenu(null); // 메뉴 열고 닫을 때 서브메뉴 초기화
  };

  // ✅ 서브메뉴 토글 함수
  const toggleSubMenu = (menuName) => {
    setOpenSubMenu(openSubMenu === menuName ? null : menuName);
  };

  // ✅ 메뉴와 서브메뉴를 모두 닫는 함수
  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setOpenSubMenu(null);
  };

  return (
    <div className="navbar-wrapper">
      <div className="navbar">
        <Link to="/" className="logoN" aria-label="홈으로">
          <picture>
      <source media="(max-width: 768px)" srcSet={logoFImage} />
      <img
        src={logoImage}
        alt="히어로 이미지"
        className="Logoo"
      />
    </picture>
        </Link>

        {/* ✅ 모바일용 햄버거 버튼 (CSS에서 데스크탑일 때 숨김 처리) */}
        <div className="hamburger" onClick={toggleMenu}>
          <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
        </div>

        {/* ✅ 메뉴 목록 (active 클래스로 모바일에서 보임/숨김 제어) */}
        <div className={`menu-nav ${isMenuOpen ? "active" : ""}`} role="menubar">
          
          {/* 센터소개 */}
          <div className="menu-item-with-sub" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('center')}>
              센터소개
            </div>
            <div className={`submenu ${openSubMenu === 'center' ? 'active' : ''}`} role="menu">
              <Link to="/intro" role="menuitem" onClick={closeAllMenus}>인사말</Link>
              <Link to="/map" role="menuitem" onClick={closeAllMenus}>오시는길</Link>
              <Link to="/vision" role="menuitem" onClick={closeAllMenus}>센터만의 비전</Link>
            </div>
          </div>

          {/* 입소안내 */}
          <div className="menu-item-with-sub" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('admission')}>
              이용안내
            </div>
            <div className={`submenu ${openSubMenu === 'admission' ? 'active' : ''}`} role="menu">
              <Link to="/admission" role="menuitem" onClick={closeAllMenus}>이용대상</Link>
              <Link to="/procedure" role="menuitem" onClick={closeAllMenus}>이용절차</Link>
              <Link to="/charge" role="menuitem" onClick={closeAllMenus}>이용요금</Link>
            </div>
          </div>

          {/* 봉사안내 */}
          <div className="menu-item-with-sub" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('volunteer')}>
              봉사안내
            </div>
            <div className={`submenu ${openSubMenu === 'volunteer' ? 'active' : ''}`} role="menu">
              <Link to="/volunteer" role="menuitem" onClick={closeAllMenus}>봉사 안내</Link>
            </div>
          </div>

          {/* 활동안내 */}
          <div className="menu-item-with-sub" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('activity')}>
              활동안내
            </div>
            <div className={`submenu ${openSubMenu === 'activity' ? 'active' : ''}`} role="menu">
              <Link to="/meal" role="menuitem" onClick={closeAllMenus}>소식지</Link>
              <Link to="/recreation" role="menuitem" onClick={closeAllMenus}>신체·인지 프로그램</Link>
            </div>
          </div>

          {/* SNS안내 */}
          <div className="menu-item-with-sub" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('sns')}>
              SNS안내
            </div>
            <div className={`submenu ${openSubMenu === 'sns' ? 'active' : ''}`} role="menu">
              <Link to="/blog" role="menuitem" onClick={closeAllMenus}>블로그</Link>
              <Link to="/instagram" role="menuitem" onClick={closeAllMenus}>인스타그램</Link>
              <Link to="/youtube" role="menuitem" onClick={closeAllMenus}>유튜브</Link>
            </div>
          </div>

          {/* 게시판 */}
          <div className="menu-item-with-sub submenu-right" role="none">
            <div className="menu-nav-item" role="menuitem" onClick={() => toggleSubMenu('board')}>
              게시판
            </div>
            <div className={`submenu ${openSubMenu === 'board' ? 'active' : ''}`} role="menu">
              <Link to="/gallery" role="menuitem" onClick={closeAllMenus}>갤러리</Link>
              <Link to="/notice" role="menuitem" onClick={closeAllMenus}>공지사항</Link>
            </div>
          </div>

          {/* 로그인/로그아웃 버튼 (모바일 메뉴 안에 포함) */}
          <div className="mobile-auth-container">
             {isLoggedIn ? (
              <div className="log-nav" onClick={handleLogout}>로그아웃</div>
            ) : (
              <Link to="/adLogin" className="log-nav" onClick={closeAllMenus}>관리자 로그인</Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};